export default {
      id: "shipment__container-usage",
      viewBox: "0 0 23 22",
      url: __webpack_public_path__ + "img/icons.svg#shipment__container",
      toString: function () {
        return this.url;
      }
    }